import { Component, OnInit, OnDestroy, Input, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Subject } from 'rxjs';
import 'datatables.net';
import { ToastrService } from 'ngx-toastr';
import { DataTableDirective } from 'angular-datatables';
import { StringUtil } from '../../../../../infra/string-util';
import { NgZone } from '@angular/core';
import { UsuarioService } from '../../../../../services/usuario.service';
import { OrdenacaoDataTables, Usuario } from '../../../../../interfaces/usuario/usuario.interface';
import { PermissaoService } from '../../../../../services/permissao.service';
import { OptionPermissao } from '../../../../../interfaces/usuario/permissao.interface';
import { EnumOrdenacaoUsuario } from '../../../../../enums/ordenacao-usuario.enum';
import { RequestSalvarStatusUsuario } from '../../../../../interfaces/usuario/usuario.interface';
import { AuthService } from '../../../../../services/auth.service';
@Component({
  selector: 'app-lista-usuarios',
  templateUrl: './lista-usuarios.component.html',
  styleUrls: ['./lista-usuarios.component.css'],
  standalone: false
})
export class ListaUsuariosComponent implements OnInit, OnDestroy {
  constructor(
    private usuarioService: UsuarioService,
    private toastr: ToastrService,
    private ngZone: NgZone,
    private changeDetectorRef: ChangeDetectorRef,
    private permissaoService: PermissaoService,
    private authService: AuthService
  ) { }

  mostrarModalGestaoAcessos: boolean = false;
  mostrarModalCadastroUsuario: boolean = false;
  usuarios: Usuario[] = [];
  usuarioSelecionado?: Usuario = undefined;
  carregando: boolean = false;
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  todasPermissoes: OptionPermissao[] = [];
  alterandoStatus: boolean = false;

  async ngOnInit(): Promise<void> {
    try {
      this.dtOptions = {
        dom: '<"row"<"col-6 mb-2"l><"col-6 text-end search-container"f>>' +
          '<"row"<"col-12 mb-2 tinfo-usuarios"i>>' +
          '<"row tbody-usuarios"<"col-sm-12"tr>>' +
          '<"row tfooter-usuarios"<"col-12"p>>',
        serverSide: true,
        searching: true,
        lengthChange: true,
        lengthMenu: [10, 25, 50, 100],
        responsive: true,
        info: true,
        pageLength: 10,
        processing: false,
        pagingType: 'simple_numbers',
        order: [[1, 'asc']],
        language: {
          processing: "Processando...",
          zeroRecords: "Nenhum contato encontrado",
          emptyTable: "Nenhum contato disponível",
          paginate: {
            previous: "Anterior",
            next: "Próximo"
          },
          info: "Mostrando _START_ até _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 até 0 de 0 registros",
          infoFiltered: "(filtrado de _MAX_ registros no total)",
          search: '',
          searchPlaceholder: 'Digite para pesquisar...',
          lengthMenu: '_MENU_ &nbsp; registros por página'
        },
        createdRow: function (row: Node, data: Usuario, index: number) {
          const isMasterComLoginPorEmail = data.master && data.loginPorEmail;
          const isNaoMaster = !data.master;
          
          if (isMasterComLoginPorEmail) {
            $(row).addClass('row-master-highlight');
          }
          else if ((data.master && !data.loginPorEmail) || 
                   (isNaoMaster && ((data.loginPorEmail && !data.temPermissoes) || !data.loginPorEmail))) {
            $(row).addClass('row-inactive');
            $(row).find('.material-symbols-outlined').addClass('text-gray');
            $(row).find('.btn-outline-primary').addClass('btn-inactive');
          }
        },
        columns: [
          {
            data: 'login',
            title: 'Login',
            orderable: false,
            width: '25%'
          },
          {
            data: 'nome',
            title: 'Nome',
            orderable: true,
            width: '15%'
          },
          {
            data: 'email',
            title: 'Email',
            orderable: true,
            width: '30%'
          },
          {
            data: 'dataCriacao',
            title: 'Cadastro',
            orderable: false,
            width: '10%',
            render: (data: string) => new Date(data).toLocaleDateString('pt-BR')
          },
          {
            data: 'ativo',
            title: 'Ativo',
            orderable: false,
            width: '5%',
            render: (data: any, type: any, row: any) => {
              const switchId = `${row.idUsuario}-${row.idCliente}`;
              return `<label class="switch">
                          <input class="slider-status-usuario" type="checkbox" ${data ? 'checked' : ''} 
                                 data-id-cliente="${row.idCliente}" 
                                 data-id-usuario="${row.idUsuario}"
                                 data-is-master="${row.master}">
                          <span class="slider"></span>
                      </label>`;
            }
          },
          {
            data: null,
            title: '',
            orderable: false,
            width: '15%',
            createdCell: function (cell: any, cellData: any, rowData: any) {
              $(cell).addClass('btn-acoes-usuario text-center items-center flex');
            },
            targets: "td",
            render: function (data: any, type: any, row: any) {
              const master = row.master ? 'visibility: visible;' : 'visibility: hidden;';
              const isNaoMaster = !row.master;
              const deveEstarInativo = (row.master && !row.loginPorEmail) || 
                                     (isNaoMaster && ((row.loginPorEmail && !row.temPermissoes) || !row.loginPorEmail));
              const buttonClass = deveEstarInativo ? 'btn-inactive' : '';
              return `<span class="badge-master" style="${master}">master</span>
                        <button class="btn btn-editar-usuario btn-outline-primary btn-icon ${buttonClass}" 
                                data-usuario='${JSON.stringify(row)}'
                                data-id-usuario="${row.idUsuario}"
                                data-id-cliente="${row.idCliente}">
                          <span class="material-symbols-outlined">edit</span>
                      </button>
                      <button class="btn btn-outline-primary btn-icon gestao-acessos ${buttonClass}" 
                              data-usuario='${JSON.stringify(row)}'
                              data-id-usuario="${row.idUsuario}"
                              data-id-cliente="${row.idCliente}">
                          <span class="material-symbols-outlined">
                              settings
                          </span>
                      </button>`;
            }
          }
        ],
        drawCallback: (settings: any) => {
          $('.btn-editar-usuario').on('click', (event) => {
            const usuario = JSON.parse($(event.currentTarget).attr('data-usuario') || '{}');
            this.ngZone.run(() => {
              this.abrirModalEdicaoUsuario(usuario);
            });
          });

          $('.slider-status-usuario').on('change', (event) => {
            const target = event.currentTarget as HTMLInputElement;
            const idUsuario = target.getAttribute('data-id-usuario');
            const idCliente = target.getAttribute('data-id-cliente');

            if (idUsuario && idCliente) {
              this.ngZone.run(() => {
                this.onSwitchChange(event);
              });
            }
          });

          $('.gestao-acessos').on('click', (event) => {
            const usuario = JSON.parse($(event.currentTarget).attr('data-usuario') || '{}');
            this.abrirModalGestaoAcessos(usuario);
          });
        },
        ajax: (dataTablesParameters: any, callback: any) => {
          this.carregando = true;
          const pagina = (dataTablesParameters.start / dataTablesParameters.length) + 1;
          const termoPesquisa = dataTablesParameters.search.value;
          const ordenacao = this.obterOrdenacaoUsuario(dataTablesParameters.order[0]);
          this.usuarioService
            .buscarUsuarios(pagina, dataTablesParameters.length, ordenacao, termoPesquisa)
            .then(response => {
              this.usuarios = response.usuarios;
              callback({
                recordsTotal: response.totalUsuarios,
                recordsFiltered: response.totalUsuarios,
                data: response.usuarios
              });
              this.carregando = false;
            })
            .catch(error => {
              console.error('Erro ao carregar usuários:', error);
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              this.carregando = false;
            });
        }
      };
    } catch (error) {
      console.error('Erro ao carregar usuários:', error);
      this.carregando = false;
    }
    finally {
      await this.obterPermissoes();
    }
  }

  obterOrdenacaoUsuario(ordenacao: OrdenacaoDataTables): EnumOrdenacaoUsuario {
    if (ordenacao.column === 1) {
      return ordenacao.dir === 'asc' ? EnumOrdenacaoUsuario.NomeAsc : EnumOrdenacaoUsuario.NomeDesc;
    }
    if (ordenacao.column === 2) {
      return ordenacao.dir === 'asc' ? EnumOrdenacaoUsuario.EmailAsc : EnumOrdenacaoUsuario.EmailDesc;
    }

    return EnumOrdenacaoUsuario.NomeAsc;
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  recarregarTabela(): void {
    if (this.dtElement) {
      this.dtElement.dtInstance.then((dtInstance: any) => {
        dtInstance.ajax.reload(null, false);
      });
    }
  }

  abrirModalGestaoAcessos(usuario: Usuario): void {
    this.usuarioSelecionado = usuario;
    this.mostrarModalGestaoAcessos = true;
    this.changeDetectorRef.detectChanges();
  }

  fecharModalGestaoAcessos(): void {
    this.mostrarModalGestaoAcessos = false;
    this.usuarioSelecionado = undefined;
    this.changeDetectorRef.detectChanges();
  }

  async obterPermissoes(): Promise<void> {
    this.todasPermissoes = await this.permissaoService.obterTodasPermissoes();
  }

  abrirModalCadastroUsuario(): void {    
    this.mostrarModalCadastroUsuario = true;
    this.changeDetectorRef.detectChanges();
  }

  abrirModalEdicaoUsuario(usuario: Usuario):void {
    this.usuarioSelecionado = usuario;

    if(this.usuarioSelecionado && this.usuarioSelecionado.master && !this.authService.getIsMaster()) {
      this.toastr.error('Você não tem permissão para editar usuários master.');
      return;
    }

    this.mostrarModalCadastroUsuario = true;
    this.changeDetectorRef.detectChanges();
  }
  
  fecharModalCadastroUsuario(): void {
    this.mostrarModalCadastroUsuario = false;
    this.usuarioSelecionado = undefined;
    this.changeDetectorRef.detectChanges();
  }

  async onSwitchChange(event: any): Promise<void> {
    const target = event.target as HTMLInputElement;
    const idUsuario = target.getAttribute('data-id-usuario');
    const idCliente = target.getAttribute('data-id-cliente');
    const isMaster = target.getAttribute('data-is-master') === 'true';
    const ativo = target.checked;
  
    if (this.alterandoStatus) {
      this.toastr.warning("Aguarde, já existe uma operação de alteração de status em andamento.");
      target.checked = !ativo;
      return;
    }
  
    if (!this.validarDadosAlterarStatus(idUsuario ?? undefined, idCliente ?? undefined, isMaster ?? false)) {
      target.checked = !ativo;
      return;
    }
  
    try {
      this.alterandoStatus = true;
      this.toastr.info('Alterando status do usuário...');
      const param: RequestSalvarStatusUsuario = {
        idUsuario: parseInt(idUsuario ?? "0", 10),
        idCliente: parseInt(idCliente ?? "0", 10),
        ativo: ativo
      };
      
      let retorno = await this.usuarioService.alterarStatusUsuario(param);      
      if(retorno.includes('Dados salvos com sucesso')){
        this.toastr.success(retorno);
      }
      else {
        this.toastr.warning(retorno);
      }

      this.atualizarDadosUsuarioLocal(parseInt(idUsuario ?? "0", 10), parseInt(idCliente ?? "0", 10), ativo);
    } catch (error) {
      console.error('Erro inesperado:', error);
      target.checked = !ativo;
    } finally {
      this.alterandoStatus = false;
    }
  }

  validarDadosAlterarStatus(idUsuario?: string, idCliente?: string, isMaster?: boolean): boolean {
    if(!idUsuario || !idCliente) {
      this.toastr.error('Erro ao alterar status do usuário. Id não configurado.');
      return false;
    }

    if(!this.permissaoService.canCriarNovosUsuarios()) {
      this.toastr.error('Erro ao alterar status do usuário. Permissão não configurada.');
      return false;
    }

    if(isMaster && !this.authService.getIsMaster()) {
      this.toastr.error('Você não tem permissão para concluir essa operação.');
      return false;
    }

    const numeroIdUsuario = parseInt(idUsuario, 10);
    const numeroIdCliente = parseInt(idCliente, 10);

    if(isNaN(numeroIdUsuario) || isNaN(numeroIdCliente) || numeroIdUsuario <= 0 || numeroIdCliente <= 0) {
      this.toastr.error('Erro ao alterar status do usuário. ID inválido.');
      return false;
    }
    return true;  
  }

  private atualizarDadosUsuarioLocal(idUsuario: number, idCliente: number, novoStatus: boolean): void {
    const usuarioIndex = this.usuarios.findIndex(
      u => u.idUsuario === idUsuario && u.idCliente === idCliente
    );
    
    if (usuarioIndex !== -1) {
      const usuarioAtualizado = { ...this.usuarios[usuarioIndex], ativo: novoStatus };
      this.usuarios[usuarioIndex] = usuarioAtualizado;
      
      this.ngZone.run(() => {
        setTimeout(() => {
          const botoesSelector = `.btn-editar-usuario[data-id-usuario="${idUsuario}"][data-id-cliente="${idCliente}"], .gestao-acessos[data-id-usuario="${idUsuario}"][data-id-cliente="${idCliente}"]`;
          const botoes = document.querySelectorAll(botoesSelector);
          
          if (botoes.length === 0) {
            const todosBotoes = document.querySelectorAll('.btn-editar-usuario, .gestao-acessos');
            todosBotoes.forEach(botao => {
              const botaoEl = botao as HTMLElement;
              const dadosUsuario = JSON.parse(botaoEl.getAttribute('data-usuario') || '{}');
              
              if (dadosUsuario.idUsuario === idUsuario && dadosUsuario.idCliente === idCliente) {
                dadosUsuario.ativo = novoStatus;
                botaoEl.setAttribute('data-usuario', JSON.stringify(dadosUsuario));
              }
            });
          } else {
            botoes.forEach(botao => {
              const botaoEl = botao as HTMLElement;
              const dadosUsuario = JSON.parse(botaoEl.getAttribute('data-usuario') || '{}');
              dadosUsuario.ativo = novoStatus;
              botaoEl.setAttribute('data-usuario', JSON.stringify(dadosUsuario));
            });
          }
        }, 0); 
      });
    }
  }
}
